import api from "@/api";
const state = {
  list: { data: [], paging: {} }
};
const getters = {
  list: state => {
    return state.list;
  }
};
const actions = {
  async getList({ commit }, params) {
    const result = await api.get(`/api/v1/purchase/view_request_item/`, params);
    if (result && result.status == 200) {
      commit("setList", result.data);
      return result.data;
    }
    return null;
  },
  async approve({ commit }, payload) {
    const res = await api.put(
      `/api/v1/purchase/request_item_action/${payload.id}/`,
      { quantity: payload.quantity, is_approved: payload.status }
    );
    if (res && res.status == 200 && res.data.data.code == 200) {
      commit("update", payload);
      return res.data.data;
    }
    return null;
  }
};
const mutations = {
  setList: (state, payload) => {
    state.list = { data: payload.data, paging: payload.paging };
  },
  update: (state, payload) => {
    var item = state.list.data.find(o => {
      return o.id == payload.id;
    });
    if (item) {
      if (payload.status == 1) {
        item.request_status = "Approved";
        item.quantity = payload.quantity;
      } else if (payload.status == 2) {
        item.request_status = "Disapproved";
        state.list.data = state.list.data.filter(o => {
          return o.id != payload.id;
        });
      }
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
